import * as yup from 'yup'

export const plannedEventsSchema = yup.object({
	next_trim_fixed_days: yup
		.string()
		.required('Введите данные')
		.matches(/^\d+$/, 'Введите только число'),
})
